import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { TableComponent } from './TableComponent';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadExcel } from '../utils/downloadExcel';
import { useEffect, useState } from 'react';
import { calculateNpsScore } from '../utils/calculateNpsScore';
import { detractors, promoters } from '../constants/constants';
import { FeedbackTableRow } from './FeedbackTableRow';

export const DSEWiseNPSTable = ({ data }) => {
  const [dseWiseNPS, setDseWiseNPS] = useState([]);
  const [keys, setKeys] = useState([]);
  function calculateDseNps(responses) {
    const dseNps = {};

    for (const response of responses) {
      const DSE = response.DSE;
      if (response.feedback) {
        if (!dseNps[DSE]) {
          dseNps[DSE] = {
            promoters: 0,
            detractors: 0,
            total: 0,
          };
        }

        if (promoters.includes(response.feedback)) {
          dseNps[DSE].promoters++;
        } else if (detractors.includes(response.feedback)) {
          dseNps[DSE].detractors++;
        }
        dseNps[DSE].total++;
      }
    }
    let dseArr = [];

    for (const DSE in dseNps) {
      const { promoters, detractors, total } = dseNps[DSE];
      let NPS = calculateNpsScore(promoters, detractors, total);
      NPS = NPS.toFixed(0);
      dseArr.push({ 'Sales Executive': DSE, NPS });
    }

    return dseArr;
  }

  useEffect(() => {
    if (data) {
      const tableData = calculateDseNps(data);
      setDseWiseNPS(tableData);
      const allKeys = Array.from(
        new Set(tableData.flatMap((row) => Object.keys(row)))
      );
      setKeys(allKeys);
    }
  }, [data]);

  return (
    <div className="dark">
      <Card
        variant="outlined"
        sx={{
          boxShadow: 3,
          width: '100%',
          p: '15px',
          background: '#1d2637',
          color: 'white',
          fontFamily: 'Montserrat, serif !important',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="space-between"
          marginBottom={2}
          marginTop={2}
        >
          <Typography
            variant="overline"
            gutterBottom
            sx={{ color: 'white', fontFamily: 'Montserrat, serif !important' }}
          >
            Sales Executive-Wise NPS Data
          </Typography>
        </Box>

        <Divider />
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="start"
          marginBottom={2}
          marginTop={2}
        >
          <Button
            variant="outlined"
            color="#e62552"
            onClick={() => downloadExcel(dseWiseNPS, 'dse-wise-nps')}
            startIcon={<DownloadIcon />}
            sx={{ fontFamily: 'Montserrat, serif !important' }}
          >
            Export Sales Executive-Wise NPS Data
          </Button>
        </Box>

        <TableComponent page={0} handleChangePage={()=>{}} data={dseWiseNPS}>
          {dseWiseNPS.map((item, index) => {
            return (
              <FeedbackTableRow
                key={index}
                allKeys={keys}
                item={item}
                index={index}
              />
            );
          })}
        </TableComponent>
      </Card>
    </div>
  );
};
